export class QuickViewEventDTO {
  data: any
  fieldName: string
}
